import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreakClockService {
  private breakConfirmationSubject$ = new Subject<void>();
  private breakClockSubject$ = new Subject<void>();
  constructor() { }

  breakConfirmation() {
    this.breakConfirmationSubject$.next(); // Notify subscribers
  }

  subscribeBreakObs(): Observable<void> {
    return this.breakConfirmationSubject$.asObservable();
  }

  publishBreakClock(){
    this.breakClockSubject$.next();
  }

  subscribeBreakClock(): Observable<any> {
    return this.breakClockSubject$.asObservable();
  }
}
